
















































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({ name: "CitaDetalleDialog" })
export default class CitaDetalleDialog extends Vue {
  @Prop({ default: false }) public value!: boolean;
  @Prop({ default: null }) public detalle!: any;
  @Prop({ default: null }) public accionLoading!: string | null;
  @Prop({ required: true }) public formatFecha!: (v: string) => string;
  @Prop({ required: true }) public colorEstado!: (codigo: string) => string;
  @Prop({ required: true }) public etiquetaAccion!: (accion: string) => string;
  @Prop({ required: true }) public colorAccion!: (accion: string) => string;

  public copiedField: string | null = null;

  get accionesDisponibles(): string[] {
    if (!this.detalle) {
      return [];
    }
    if (this.detalle.estado_codigo === "cancelacion_pendiente_gesden") {
      return ["confirmar_cancelacion_gesden", "marcar_conflicto"];
    }
    if (this.detalle.estado_codigo === "reagendado_pendiente_gesden") {
      return ["confirmar_reagendado_gesden", "marcar_conflicto"];
    }
    return this.detalle.allowed_actions || [];
  }

  public onDialogInput(v: boolean) {
    this.$emit("input", v);
  }

  public irAlCalendario() {
    if (!this.detalle) { return; }
    const fecha = (this.detalle.fecha_hora_inicio_solicitada || "").substring(0, 10);
    this.$router.push({
      name: "agenda_calendar_admin",
      query: {
        ...(fecha ? { fecha } : {}),
        ...(this.detalle.id ? { cita_id: String(this.detalle.id) } : {}),
      },
    }).catch(() => { /* misma ruta */ });
    this.$emit("input", false);
  }

  public async copiarCampo(field: string, valor: any) {
    try {
      await navigator.clipboard.writeText(valor ? String(valor) : "");
      this.copiedField = field;
      setTimeout(() => {
        if (this.copiedField === field) {
          this.copiedField = null;
        }
      }, 1500);
    } catch (e) {
      // silencio: no bloquear flujo por clipboard
    }
  }

  public iconoCopiado(field: string): string {
    return this.copiedField === field ? "mdi-check" : "mdi-content-copy";
  }

  public iconoCopia(field: string): string {
    return this.copiedField === field ? "success" : "grey";
  }

  public iconoAccion(accion: string): string {
    const iconos: Record<string, string> = {
      marcar_en_revision: "mdi-eye-check",
      confirmar: "mdi-check-circle",
      marcar_enviada_gesden: "mdi-send",
      marcar_insertada_gesden: "mdi-database-check",
      cancelacion_pendiente_gesden: "mdi-calendar-remove",
      reagendado_pendiente_gesden: "mdi-calendar-arrow-right",
      marcar_conflicto: "mdi-alert-circle",
      marcar_fallida_gesden: "mdi-alert-octagon",
      rechazar: "mdi-close-circle",
      cancelar: "mdi-cancel",
      expirar: "mdi-timer-sand-empty",
      confirmar_cancelacion_gesden: "mdi-check-decagram",
      confirmar_reagendado_gesden: "mdi-calendar-check",
    };
    return iconos[accion] || "mdi-lightning-bolt";
  }

  public descripcionAccion(accion: string): string {
    const descripciones: Record<string, string> = {
      marcar_en_revision:
        "Marcar para revisión administrativa antes de decidir.",
      confirmar: "Confirmar la cita para continuar el flujo operativo.",
      marcar_enviada_gesden: "Registrar que la cita ya fue enviada a GESDEN.",
      marcar_insertada_gesden:
        "Confirmar que la cita ya está insertada en GESDEN.",
      cancelacion_pendiente_gesden:
        "Si la cita está insertada en GESDEN, inicia la cancelación pendiente en GESDEN.",
      reagendado_pendiente_gesden:
        "Si la cita está insertada en GESDEN, inicia el reagendado pendiente en GESDEN.",
      marcar_conflicto: "Marcar incidencia para resolución manual.",
      marcar_fallida_gesden: "Registrar fallo de sincronización con GESDEN.",
      rechazar: "Rechazar la solicitud y cerrar el caso.",
      cancelar: "Cancelar la solicitud de cita.",
      expirar: "Marcar como expirada por falta de gestión en plazo.",
      confirmar_cancelacion_gesden:
        "Confirmar que la cancelación ya se ejecutó en GESDEN.",
      confirmar_reagendado_gesden:
        "Confirmar que el cambio de fecha ya se ejecutó en GESDEN.",
    };
    return descripciones[accion] || this.etiquetaAccion(accion);
  }

  public dispararAccion(accion: string) {
    if (!this.detalle || !this.detalle.id) {
      return;
    }
    if (accion === "confirmar_cancelacion_gesden") {
      this.$emit("accion-con-mensaje", {
        id: this.detalle.id,
        accion,
        mensajeOk: "Cancelación confirmada en GESDEN",
      });
      return;
    }
    if (accion === "confirmar_reagendado_gesden") {
      this.$emit("accion-con-mensaje", {
        id: this.detalle.id,
        accion,
        mensajeOk: "Reagendado confirmado en GESDEN",
      });
      return;
    }
    if (
      accion === "marcar_conflicto" &&
      ["cancelacion_pendiente_gesden", "reagendado_pendiente_gesden"].includes(
        this.detalle.estado_codigo
      )
    ) {
      this.$emit("accion-con-mensaje", {
        id: this.detalle.id,
        accion,
        mensajeOk: "Marcado como conflicto",
      });
      return;
    }
    this.$emit("accion", { id: this.detalle.id, accion });
  }
}
